import { Directive, inject } from '@angular/core'
import { ElderEnumTranslationService, ElderSelectComponent } from '@elderbyte/ngx-starter'
import { KnownProductionListProperties } from './production-list-property-resolve-spec'

@Directive({
  selector: '[appKnownPropertySelect]',
})
export class KnownProductionListPropertySelectDirective {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private select = inject(ElderSelectComponent)
  private enumTranslationService = inject(ElderEnumTranslationService)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    this.select.placeholder = 'properties.property'
    this.select.displayProperty = 'displayValue'

    this.select.dataSource = this.enumTranslationService.enumDataSource(
      KnownProductionListProperties,
      'KnownProperties'
    )
  }
}
